import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'

import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState
} from 'recoil'
import {
  Panel,
  Flex,
  FlexItem,
  Text,
  TEXT_VARIANT_LIGHT,
  IconForward7,
  IconWorkflow,
  Link,
  LINK_VARIANT_EXTRALIGHT
} from 'mailup-web-components'
import {
  mdCheckup,
  messageState,
  modalNoEdit
} from 'Pages/MessageCheckupSummary/recoil/state/message'
import {
  callbackManagerAlert,
  changeAlertCallback,
  mdCheckupStateCallback
} from 'Pages/MessageCheckupSummary/recoil/callbacks/callbacks'
import SummaryDynamicFieldCheck from './SummaryDynamicFieldCheck/SummaryDynamicFieldCheck'

import SummaryLinkCheck from './SummaryLinkCheck/SummaryLinkCheck'
import { notifyParent } from 'Helpers/notifyParent'
import {
  EmailMessageCheckUpIssueType,
  MESSAGE_STR_TYPE_CONTENTSCAMPAIGN
} from 'Constants/'

import { sendingMessageCallback } from 'Pages/OverviewMessage/recoil/callbacks/callbacks'
import { pageState } from 'Pages/MessageCheckupSummary/recoil/state/page'
import { ENTITY_TYPE_AUTOMATION_WORKFLOW } from 'Constants/index'
import { modalManageAlertsState } from 'Pages/MessageCheckupSummary/recoil/state/modals'
import { IconWrapperSmall } from '../commonComponents/commonComponents'
import CheckItem, {
  ICON_ALERT,
  ICON_CHECK
} from 'Components/CheckItem/CheckItem'
import styled from '@emotion/styled'

const PotentialDetails = () => {
  const intl = useIntl()
  const history = useHistory()
  const { id: idMessage, isBee, idCampaign, messageType } = useRecoilValue(
    messageState
  )

  const [
    {
      wrongDynamicTags,
      checkLinksWoTracking,
      checkUnsubscribeLink,
      checkMaxSize,
      checkSize,
      checkBlacklistResult,
      checkWorkflowWarning,
      silencedAlertsArray,
      workflowsEntities
    },
    setMdState
  ] = useRecoilState(mdCheckup)
  const { canSaveFromPage } = useRecoilValue(modalManageAlertsState)
  const getMdCheckupState = useRecoilCallback(mdCheckupStateCallback, [])
  const saveManagerAlert = useRecoilCallback(callbackManagerAlert, [])
  const isSendingMessage = useRecoilCallback(sendingMessageCallback)
  const setModalNoEdit = useSetRecoilState(modalNoEdit)
  const setPageState = useSetRecoilState(pageState)

  const changeAlert = useRecoilCallback(changeAlertCallback, [])

  useEffect(() => {
    getMdCheckupState(idMessage)
  }, [idMessage])

  const propsKo = () => ({
    icon: ICON_ALERT
  })

  const propsOk = () => ({
    icon: ICON_CHECK
  })

  const handleSizeLink = () => {
    notifyParent('redirectMainFrame', ['form_upd_nl.aspx?tab=opzioni'])
  }

  const handleSizeLink1 = () => {
    if (isBee) {
      history.push(`/messages/email/bee/edit/${idMessage}`)
    } else {
      notifyParent('redirectMainFrame', [
        `form_upd_newsletter.aspx?isNew=true&idNL=${idMessage}`
      ])
    }
  }

  const handleBlackListLink1 = () => {
    if (isBee) {
      history.push(`/messages/email/bee/edit/${idMessage}`)
    } else {
      notifyParent('redirectMainFrame', [
        `form_upd_newsletter.aspx?isNew=true&idNL=${idMessage}`
      ])
    }
  }

  const handleBlackListLink2 = () => {
    const route = `/messages/email/${idMessage}/checkup/linkcheck`
    history.push(route)
  }

  const handleLinkTracking = () => {
    history.push(`/messages/email/${idMessage}/overview`)
  }

  useEffect(() => {
    // save only when modal is unvisible
    if (canSaveFromPage) {
      const atLeastOneModified = silencedAlertsArray.some(e => e.stateManaged)
      if (atLeastOneModified) {
        saveManagerAlert(idMessage)
      }
    }
  }, [silencedAlertsArray, canSaveFromPage])

  const handleListClick = (id, type) => {
    const destUrl =
      type === ENTITY_TYPE_AUTOMATION_WORKFLOW
        ? `automation_app_redirector.aspx?r=${encodeURIComponent(
            `/automation/workflow/${id}/edit`
          )}`
        : `automation_app_redirector.aspx?r=${encodeURIComponent(
            `/automation/task/${id}`
          )}`
    notifyParent('redirectMainFrame', [destUrl])
  }

  const handleUnsubscribeLink = () => {
    isSendingMessage(idMessage).then(isSending => {
      if (!isSending) {
        if (isBee && messageType === MESSAGE_STR_TYPE_CONTENTSCAMPAIGN) {
          notifyParent('redirectMainFrame', [
            `App.aspx#/beePluginEditor/editCMP/${idCampaign}`
          ])
        }
        if (isBee && messageType !== MESSAGE_STR_TYPE_CONTENTSCAMPAIGN) {
          history.push(`/messages/email/bee/edit/${idMessage}`)
        }
        if (!isBee) {
          notifyParent('redirectMainFrame', [
            `form_upd_newsletter.aspx?source=listemail&idNL=${idMessage}`
          ])
        }
      } else {
        setPageState(pageState, prev => ({
          ...prev,
          inlineMessage: intl.formatMessage({
            id: 'Load.EmailMessageList.MessageIsOnSentWarning'
          }),
          inlineMessageSeverity: 'warning'
        }))
        setModalNoEdit(true)
      }
    })
  }

  const strAutomationTask = intl.formatMessage({
    id: 'Load.Common.AutomationTask'
  })
  const strWorkflow = intl.formatMessage({
    id: 'Load.Common.Workflow'
  })
  const strId = intl.formatMessage({
    id: 'Load.MailupCommon.Id'
  })

  const workflowsDetails = workflowsEntities.map(e => (
    <Flex padding='8px 8px 8px 0' alignItems='flexStart' key={e.name}>
      <FlexItem padding='8px 8px 8px 0'>
        <IconWrapperSmall color={'var(--sun)'} fonstSize={'18px'}>
          {e.Type === 'AutomationWorkflow' ? (
            <IconForward7 />
          ) : (
            <IconWorkflow />
          )}
        </IconWrapperSmall>
      </FlexItem>
      <FlexItem padding='8px'>
        <Text variant={TEXT_VARIANT_LIGHT}>
          {e.Type === 'AutomationWorkflow' ? strWorkflow : strAutomationTask}
        </Text>
        <Link
          variant={LINK_VARIANT_EXTRALIGHT}
          href='#'
          onClick={() => handleListClick(e.Id, e.Type)}
        >
          {strId} {e.Id} - {e.Name}
        </Link>
      </FlexItem>
    </Flex>
  ))

  return (
    <StyledPanel>
      {checkBlacklistResult.Action === 1 && (
        <CheckItem
          alert={
            silencedAlertsArray.length > 0 &&
            silencedAlertsArray.find(
              e =>
                e.issueType === EmailMessageCheckUpIssueType.BlackListUrlWarning
            ).silenced
          }
          callbackAlert={e =>
            changeAlert(
              EmailMessageCheckUpIssueType.BlackListUrlWarning,
              e.toLowerCase()
            )
          }
          {...propsKo()}
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.BlackListUrlPotentialKoTitle'
          })}
          description={intl.formatMessage(
            {
              id: 'Load.EmailCheckUp.BlackListUrlPotentialKoDesc'
            },
            {
              link1: e => (
                <Link
                  variant={LINK_VARIANT_EXTRALIGHT}
                  key='potential-link-1'
                  onClick={handleBlackListLink1}
                >
                  {e}
                </Link>
              ),
              link2: e => (
                <Link
                  variant={LINK_VARIANT_EXTRALIGHT}
                  key='potential-link-2'
                  onClick={handleBlackListLink2}
                >
                  {e}
                </Link>
              )
            }
          )}
          data-mu-test='potential-details__blacklist--ko'
        />
      )}
      {checkBlacklistResult.Action !== 1 && (
        <CheckItem
          alert={
            silencedAlertsArray.length > 0 &&
            silencedAlertsArray.find(
              e =>
                e.issueType === EmailMessageCheckUpIssueType.BlackListUrlWarning
            ).silenced
          }
          callbackAlert={e =>
            changeAlert(
              EmailMessageCheckUpIssueType.BlackListUrlWarning,
              e.toLowerCase()
            )
          }
          {...propsOk()}
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.BlackListUrlPotentialOkTitle'
          })}
          description={intl.formatMessage({
            id: 'Load.EmailCheckUp.BlackListUrlWarningDescrOK'
          })}
          data-mu-test='potential-details__blacklist--ok'
        />
      )}
      {checkLinksWoTracking && (
        <CheckItem
          alert={
            silencedAlertsArray.length > 0 &&
            silencedAlertsArray.find(
              e =>
                e.issueType === EmailMessageCheckUpIssueType.LinkTrackingWarning
            ).silenced
          }
          callbackAlert={e =>
            changeAlert(
              EmailMessageCheckUpIssueType.LinkTrackingWarning,
              e.toLowerCase()
            )
          }
          {...propsOk()}
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.LinkTrackingOkTitle'
          })}
          description={intl.formatMessage({
            id: 'Load.EmailCheckUp.LinkTrackingWarningOK'
          })}
          data-mu-test='potential-details__links-wo-tracking--ok'
        />
      )}
      {!checkLinksWoTracking && (
        <CheckItem
          alert={
            silencedAlertsArray.length > 0 &&
            silencedAlertsArray.find(
              e =>
                e.issueType === EmailMessageCheckUpIssueType.LinkTrackingWarning
            ).silenced
          }
          callbackAlert={e =>
            changeAlert(
              EmailMessageCheckUpIssueType.LinkTrackingWarning,
              e.toLowerCase()
            )
          }
          {...propsKo()}
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.LinkTrackingKoTitle'
          })}
          description={intl.formatMessage(
            {
              id: 'Load.EmailCheckUp.LinkTrackingKoDesc'
            },
            {
              link: e => (
                <Link
                  variant={LINK_VARIANT_EXTRALIGHT}
                  key='tracking-link'
                  onClick={handleLinkTracking}
                >
                  {e}
                </Link>
              )
            }
          )}
          data-mu-test='potential-details__links-wo-tracking--ko'
        />
      )}
      {!checkUnsubscribeLink && (
        <CheckItem
          alert={
            silencedAlertsArray.length > 0 &&
            silencedAlertsArray.find(
              e =>
                e.issueType ===
                EmailMessageCheckUpIssueType.UnsubscribeLinkWarning
            ).silenced
          }
          callbackAlert={e =>
            changeAlert(
              EmailMessageCheckUpIssueType.UnsubscribeLinkWarning,
              e.toLowerCase()
            )
          }
          {...propsKo()}
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.UnsubscribeLinkKoTitle'
          })}
          description={intl.formatMessage(
            {
              id: 'Load.EmailCheckUp.SummaryExistenceOfUnsubscribeLinkKoDesc'
            },
            {
              link: e => (
                <Link
                  variant={LINK_VARIANT_EXTRALIGHT}
                  key='potential-link-unsubscribe'
                  onClick={handleUnsubscribeLink}
                >
                  {e}
                </Link>
              )
            }
          )}
          data-mu-test='potential-details__unsubscribe--ko'
        />
      )}
      {checkUnsubscribeLink && (
        <CheckItem
          alert={
            silencedAlertsArray.length > 0 &&
            silencedAlertsArray.find(
              e =>
                e.issueType ===
                EmailMessageCheckUpIssueType.UnsubscribeLinkWarning
            ).silenced
          }
          callbackAlert={e =>
            changeAlert(
              EmailMessageCheckUpIssueType.UnsubscribeLinkWarning,
              e.toLowerCase()
            )
          }
          {...propsOk()}
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.UnsubscribeLinkOkTitle'
          })}
          description={intl.formatMessage({
            id: 'Load.EmailCheckUp.UnsubscribeLinkWarningDescrOK'
          })}
          data-mu-test='potential-details__unsubscribe--ok'
        />
      )}
      {wrongDynamicTags && wrongDynamicTags.length > 0 && (
        <SummaryDynamicFieldCheck idMessage={idMessage} isBee={isBee} />
      )}
      {!checkMaxSize.Check && (
        <CheckItem
          alert={
            silencedAlertsArray.length > 0 &&
            silencedAlertsArray.find(
              e => e.issueType === EmailMessageCheckUpIssueType.MaxSizeInfo
            ).silenced
          }
          callbackAlert={e =>
            changeAlert(
              EmailMessageCheckUpIssueType.MaxSizeInfo,
              e.toLowerCase()
            )
          }
          {...propsKo()}
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.MaxSizeInfoKoTitle'
          })}
          description={
            <>
              <div>
                {intl.formatMessage(
                  {
                    id: 'Load.EmailCheckUp.MaxSizeInfoKoDesc1'
                  },
                  {
                    size: intl.formatNumber(
                      checkMaxSize.Size + checkMaxSize.OverMaximumSize,
                      {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2
                      }
                    ),
                    maxSize: intl.formatNumber(checkMaxSize.Size, {
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 2
                    }),
                    link: e => (
                      <Link
                        variant={LINK_VARIANT_EXTRALIGHT}
                        key='potential-link'
                        onClick={handleSizeLink}
                      >
                        {e}
                      </Link>
                    )
                  }
                )}
              </div>
              <div>
                {intl.formatMessage(
                  {
                    id: 'Load.EmailCheckUp.MaxSizeInfoKoDesc2new'
                  },
                  {
                    link1: e => (
                      <Link
                        variant={LINK_VARIANT_EXTRALIGHT}
                        key='potential-link-1'
                        onClick={handleSizeLink1}
                      >
                        {e}
                      </Link>
                    )
                  }
                )}
              </div>
            </>
          }
          data-mu-test='potential-details__max-size--ko'
        />
      )}
      {checkMaxSize.Check && (
        <CheckItem
          alert={
            silencedAlertsArray.length > 0 &&
            silencedAlertsArray.find(
              e => e.issueType === EmailMessageCheckUpIssueType.MaxSizeInfo
            ).silenced
          }
          callbackAlert={e =>
            changeAlert(
              EmailMessageCheckUpIssueType.MaxSizeInfo,
              e.toLowerCase()
            )
          }
          {...propsOk()}
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.MaxSizeInfoOkTitle'
          })}
          description={intl.formatMessage(
            {
              id: 'Load.EmailCheckUp.MaxSizeInfoOkDesc'
            },
            {
              size: intl.formatNumber(checkSize.Size / 1024, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
              })
            }
          )}
          data-mu-test='potential-details__max-size--ok'
        />
      )}
      {checkWorkflowWarning && (
        <CheckItem
          alert={
            silencedAlertsArray.length > 0 &&
            silencedAlertsArray.find(
              e => e.issueType === EmailMessageCheckUpIssueType.WorkflowWarning
            ).silenced
          }
          callbackAlert={e =>
            changeAlert(
              EmailMessageCheckUpIssueType.WorkflowWarning,
              e.toLowerCase()
            )
          }
          {...propsKo()}
          title={intl.formatMessage({
            id: 'Load.EmailCheckUp.WorkflowKoTitle'
          })}
          description={intl.formatMessage(
            {
              id: 'Load.EmailCheckUp.WorkflowKoDesc'
            },
            {
              details: workflowsDetails
            }
          )}
          data-mu-test='potential-details__workflow--ko'
        />
      )}
      <SummaryLinkCheck idMessage={idMessage} />
    </StyledPanel>
  )
}

export default PotentialDetails

const StyledPanel = styled(Panel)`
  .dynamic-field-item--container + .check-item--container {
    border-top: 1px solid var(--geyser);
    margin-top: 24px;
    padding-top: 24px;
  }
`
